import { render, staticRenderFns } from "./GoodsSpecifications.vue?vue&type=template&id=6e080534&scoped=true&lang=pug&"
import script from "./GoodsSpecifications.vue?vue&type=script&lang=ts&"
export * from "./GoodsSpecifications.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsSpecifications.vue?vue&type=style&index=0&id=6e080534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e080534",
  null
  
)

export default component.exports